import gForm from "@/components/g-form/g-form.vue";
import gButton from "@/components/g-button/g-button.vue";
import GrupoController from "@/shared/controllers/grupo/grupoController";
import GrupoViewModel from "@/shared/view-models/GrupoViewModel";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, helpers } from "@vuelidate/validators";


import gValidators from "@/shared/custom/validators/g-validators";

// import UsuarioController from "@/shared/controllers/usuario/usuarioController";

const name = 'CadastroUsuario'
export default {
  name,

  components: { 
    "g-form": gForm,
    "g-button": gButton,
  }, 

  props: { },

  mounted () {
    this.mounted();
   },

  updated () { },
  validations() {
    let senhaNova ={}
    let senhaNovaConfirmacao ={}  
    
    if(this.EditarSenha == true){
      senhaNova = {
        required: helpers.withMessage('O campo de Nova Senha é obrigatório', required),
        minLength: helpers.withMessage( `Sua senha precisa ter no mínimo 6 caracteres`, minLength(6)),
        contemEspeciais: helpers.withMessage( `Sua senha precisa ter caracteres especiais`, gValidators.contemEspeciais),
        contemMinusculas: helpers.withMessage( `Sua senha precisa ter alguma letra maiúscula`, gValidators.contemMinusculas),
        contemMaiuscula: helpers.withMessage( `Sua senha precisa ter alguma letra minúscula`, gValidators.contemMaiuscula),
        contemNumero: helpers.withMessage( `Sua senha precisa ter números`, gValidators.contemNumero),
      }
      senhaNovaConfirmacao = {
        required: helpers.withMessage('O campo de confirmação da Nova Senha é obrigatório', required)
      }
    }
      return {
        
        senhaNova : senhaNova,
        senhaNovaConfirmacao:senhaNovaConfirmacao
      
    }
  },

  setup(){
    return {
      v$: useVuelidate()
    }
  },
  data () {
    return {
      Titulo: '', 
      tipo: 'password',
      bloqueado: null,
      inativo: null,
      Colunas : [
        {field: 'nomeGrupo', header: 'Grupo', width: '120px', ordena: true},
      ],
      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeGrupo': {value: null, matchMode: this.filtros.CONTAINS}
      },
      popupExistente: false,
      GrupoArray: [],
      modoEdicao: false,
      GrupoArrayDropDown: [],
      GrupoSelecionado: null,
      UsuarioExistente: '',
      mensagemvazio: null,
      senhaNovaConfirmacao: '',
      senhaNova: '',
      EditarSenha: false,
      objFiltro: new GrupoViewModel(),
      grupoId: null,
      TempId: new Date().getTime(),
     }
  },

  watch: {
    EditarSenha(){
      if(this.EditarSenha == true){
        this.senhaNova = ''
        this.senhaNovaConfirmacao = ''
      }
    }
  },

  methods: { 
    mounted(){
      const urlParams = new URLSearchParams( window.location.search);
      if(urlParams.has('edicao')) {
        this.modoEdicao = true
      }
      this.objFiltro.Id = this.$route.params.id == "" ? null : this.$route.params.id
      if(this.objFiltro.Id != null)
      {
        this.getUsuarioEditar();
      }
      this.modoEdicao == true ? this.Titulo = 'Editar Usuário' : this.Titulo = 'Cadastrar Usuário'
      this.modoEdicao == false ? this.EditarSenha = true : this.EditarSenha = false
      this.getGruposAtivos()
    },
    mostrarSenha(){
      if(this.tipo === 'password'){
        this.tipo = 'text'
      }
      else{
        this.tipo = 'password'
      }
    },
    voltar(){
      this.$router.push('/gerenciamento-usuarios-geral')
    },

    getGruposAtivos() {
      this.$isLoading(true)
      GrupoController.getGruposAtivos().requisicao
        .then((res) => {
          this.GrupoArrayDropDown = res.data.data
          this.$isLoading(false)
        })
        .catch(() => {
          this.$isLoading(false)
        });
    },

    gravar(){
      if(this.v$.$invalid === false) {

        if(this.objFiltro.NomeUsuario == undefined){
          this.$toast.add({ severity: 'error', summary: 'Por favor, escolha um Nome de Usuário', life: 5000 });
          return
        }

        if(this.objFiltro.Login == undefined){
          this.$toast.add({ severity: 'error', summary: 'Por favor, escolha um Login', life: 5000 });
          return
        }
       
        if(this.objFiltro.Email == undefined){        
          this.$toast.add({ severity: 'error', summary: 'Por favor, digite um email', life: 5000 });
          return
        }

        if(this.objFiltro.GrupoSelecionado == undefined){
          this.$toast.add({ severity: 'error', summary: 'Selecione um grupo de Usuário!', life: 5000 });
          return
        }
        if(this.senhaNova != this.senhaNovaConfirmacao){
          this.$toast.add({ severity: 'error', summary: 'As senhas digitadas não coincidem', life: 5000 });
          return
        }
        const urlParams = new URLSearchParams( window.location.search);
        if(!urlParams.has('edicao')) {
          // this.modoEdicao = true
          this.VerificaUsuarioExistente();
        }else{
          this.salvaOuAlteraUsuario()
        }
      }
      else {
          this.v$.$silentErrors.forEach(erro =>{
            this.$toast.add({severity:'error', summary: 'ERRO', detail:erro.$message,  life: 5000})
          })
      }
    },
    TrocaPraEdicao() {
      this.$router.push(`/cadastro-usuario/${this.UsuarioExistente.id}?edicao=true`)
      this.popupExistente = false;
      this.modoEdicao = true;
      setTimeout(() => {
        this.mounted();
      },1000)
    },
    VerificaUsuarioExistente(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Usuario/VerificaUsuarioExistente`,
        data: this.objFiltro
        }).then((res) => {
          this.UsuarioExistente = res.data.data;
           if (this.UsuarioExistente != null && this.modoEdicao == false) {
            this.popupExistente = true;
          } else {
            this.salvaOuAlteraUsuario()
          }
        }).finally(()=>this.$isLoading(false))
    },
    limpaInfo() {
      this.senhaNova = ''
      this.senhaNovaConfirmacao = ''
      this.popupExistente= false;
      this.objFiltro.NomeUsuario = '';
      this.objFiltro.Email = '';
      this.objFiltro.Bloqueado = false;
      this.objFiltro.Inativo = false;
      this.objFiltro.GrupoSelecionado = null;
    },
    salvaOuAlteraUsuario() {
      this.objFiltro.Senha = this.senhaNova;
      this.objFiltro.ConfirmacaoSenha = this.senhaNovaConfirmacao;
      this.objFiltro.EditarSenha = this.EditarSenha;

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Usuario/PostUsuario`,
        data: this.objFiltro
      }).then((res) => {
        if(res.data.success)
        {

          if(this.popupExistente == true) {
            
            this.$toast.add({ severity: 'success', summary: 'Usuário alterado com sucesso!', life: 5000 });
            this.popupExistente= false
            this.modoEdicao = false

            this.Id = res.data.mensagem

            setTimeout(() => {
              this.MandarUsuarioCRM();
            }, 3000);
  
            setTimeout(() => {
              this.voltar();
            }, 2000)
          } 
          else {
            if(this.modoEdicao == true){
              this.$toast.add({ severity: 'success', summary: 'Usuário alterado com sucesso!', life: 5000 });
              this.popupExistente= false
              this.modoEdicao = false

              this.Id = res.data.mensagem

              setTimeout(() => {
                this.MandarUsuarioCRM();
              }, 3000);
    
              setTimeout(() => {
                this.voltar();
              }, 2000)
            }
            else{
              this.$toast.add({ severity: 'success', summary: 'Usuário criado com sucesso!', life: 5000 });
              this.popupExistente= false
              this.modoEdicao = false

              this.Id = res.data.mensagem

              setTimeout(() => {
                this.MandarUsuarioCRM();
              }, 3000);

              setTimeout(() => {
                this.voltar();
              }, 2000)
  
            }
          }
        }
        else{
          this.$toast.add({ severity: 'error', summary: res.data.mensagem, life: 5000 });
          this.popupExistente= false
          this.modoEdicao = false
          return
        }
      }).finally(()=>this.$isLoading(false))
    },

    MandarUsuarioCRM() {
      const statusAlterado = this.inativoOriginal === undefined
        ? true
        : this.objFiltro.Inativo !== this.inativoOriginal
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Usuario/EnviarUsuarioCRM/${this.Id}?statusAlterado=${statusAlterado}`,
      })
        .then(() => {
        })
        .catch(() => {
        });
    },
    getUsuarioEditar() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Usuario/GetUsuarioGerenciamentoById/${this.objFiltro.Id}`
      }).then((res) => {
        this.objFiltro.NomeUsuario = res.data.data.nomeUsuario
        this.objFiltro.Email = res.data.data.email
        this.objFiltro.Login = res.data.data.login
        this.objFiltro.Inativo = res.data.data.inativo
        this.inativoOriginal = res.data.data.inativo
        this.objFiltro.Bloqueado = res.data.data.bloqueado
        this.objFiltro.NomeGrupo = res.data.data.nomeGrupo
        this.objFiltro.GrupoSelecionado = res.data.data.grupoSelecionado
        this.objFiltro.DataTrocaSenha = res.data.data.alteracao
        console.log(this.objFiltro)
      })
    },
   },

  computed: { }, 

};